import React, {useEffect, useState} from 'react';
import TitleValue from "components/textValue/TitleValue";
import StandardButton from "components/buttons/StandardButton";
import IconTitleValue from "components/textValue/IconTitleValue";
import Space from "../../../components/space/Space";
import {callApi} from "../../../connection/ClientApi";
import {useHistory} from "react-router-dom";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import {Divider} from "@mui/material";
import messages from "res/messages/farsi";
import moment from "jalali-moment";
import Urls from "../../../connection/Urls";

import ICDelete from '@mui/icons-material/Delete';
import ICClock from '@mui/icons-material/AccessTime';
import ICArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ICRead from '@mui/icons-material/Drafts';
import ICUnread from '@mui/icons-material/Email';

export default function NotificationItem(props) {

    const history = useHistory()

    const [notification, setNotification] = useState()
    const [className, setClassName] = useState("")
    const [readProgressIsShow, setReadProgressIsShow] = useState(false)
    const [deleteProgressIsShow, setDeleteProgressIsShow] = useState(false)
    const [deleteDialogShowStatus, setDeleteDialogShowStatus] = useState(false)

    function requestReadNotification() {
        if (notification.is_read) {
            return
        }
        let params = new FormData()
        params.append("noty_id", notification.noty_id)
        callApi(Urls.readNotification, params, (data) => {
                if (data && data.description === 200) {
                    notification.is_read = true
                    setNotification(notification)
                    setClassName("cardAnim")
                }
            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                setReadProgressIsShow(true)
            }, () => {
                setReadProgressIsShow(false)
            }
        )
    }

    function requestDeleteNotification() {
        let params = new FormData()
        params.append("noty_id", notification.noty_id)
        callApi(Urls.deleteNotification, params, (data) => {
                if (data && data.description === 200) {
                    if (props.onDeleteNotification) {
                        props.onDeleteNotification()
                        props.onAlert(messages.deleteNotificationSuccess, ALERT_TYPES.SUCCESS)
                    }
                }
            }, () => {
                props.onAlert(messages.responseCodeIsNot200)
            }, () => {
                setDeleteProgressIsShow(true)
            }, () => {
                setDeleteProgressIsShow(false)
            }
        )
    }

    useEffect(() => {
        setClassName(props.notification && props.notification.is_read ? "cardAnim" : "cardGreen")
        setNotification(props.notification)
    }, [props])

    return (<div className="fullWidth marginSmall">
        {notification && !notification.isTemp &&
        <div className={className}>
            <div>
                <div className="horizontalFullScreen">
                    <TitleValue
                        title={notification.title}
                        titleClassName="mediumTextBold marginSmall"/>
                    <div style={{position: "absolute", left: 0}} className="horizontalScreen">
                        <StandardButton
                            loading={readProgressIsShow}
                            icon={notification.is_read ?
                                <ICRead className="yellowColor_1"/> : <ICUnread className="yellowColor_1"/>}
                            onClick={(e) => {
                                requestReadNotification()
                                e.stopPropagation()
                            }}/>
                        <StandardButton
                            loading={deleteProgressIsShow}
                            icon={<ICDelete className="pinkColor" style={{marginTop: "-0.04em"}}/>}
                            onClick={(e) => {
                                setDeleteDialogShowStatus(true)
                                e.stopPropagation()
                            }}/>
                    </div>
                </div>
                <div className="marginLeftRightSmall">
                    <TitleValue
                        title={notification.description}
                        titleClassName="mediumText"/>
                </div>
                {notification.image &&
                <div className="marginLarge center">
                    <img src={notification.image} alt="" className="fullWidth"
                         style={{width: "100%", height: "auto", aspectRatio: "16/4"}}/>
                </div>
                }
                <div className="marginLeftRightSmall marginTopSmall">
                    <Divider/>
                </div>
                <div className="horizontalFullScreen marginLeftRightSmall">
                    <IconTitleValue
                        title={notification.date_added.split(" ")[1]}
                        value={moment(notification.date_added, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('YYYY/MM/DD')}
                        valueClassName={"smallText"}
                        icon={<ICClock className="grayColor marginTopXSmall" fontSize={"inherit"}/>}/>
                    {notification.type !== "1" && notification.type !== "2" && notification.type !== "4"  &&
                    <div style={{position: "absolute", left: 5, bottom: 5}}>
                        <StandardButton
                            text={messages.detail}
                            icon={<ICArrowBackIosIcon fontSize={"small"} className="grayColor"/>}
                            textcolor={"grayColor"}
                            onClick={(e) => {
                                e.stopPropagation()
                                props.onNotificationClicked(history, notification.type, notification.data)
                            }}/>
                    </div>
                    }
                </div>
                <Space/>
            </div>
            <DialogMessage
                showStatus={deleteDialogShowStatus}
                title={messages.deleteNotification}
                message={messages.sureDeleteNotification}
                submitTitle={messages.yes}
                closeTitle={messages.no}
                onCloseClicked={() => {
                    setDeleteDialogShowStatus(false)
                }}
                onSubmitClicked={() => {
                    setDeleteDialogShowStatus(false)
                    requestDeleteNotification()
                }}
            />
        </div>
        }
    </div>)

}